/* unplugin-vue-components disabled */import { render } from "./xButton.vue?vue&type=template&id=b0d1514a"
import script from "./xButton.vue?vue&type=script&lang=js"
export * from "./xButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__